export default __webpack_public_path__ + "static/media/logo-dark-sm.c2671732.png";